<template>
  <input
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    type="range"
    class="accent-gpx_gray-100 disabled:cursor-not-allowed"
  />
</template>

<script>
export default {
  emits: ['update:modelValue'],
  props: ['modelValue'],
};
</script>
